import React from "react";
import { FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Error } from "../UI/Error";

export default function SelectField({
  data,
  label,
  error,
  register,
  disable,
  stateValue,
  setState,
  size,
  handleLoadMore,
  from
}) {
  return (
    <FormControl size={size} fullWidth variant="outlined">
      <InputLabel error={error}>{label}</InputLabel>
      <Select
        disabled={disable}
        value={stateValue ?? ""}
        label={label}
        sx={{
          textAlign: "left",
        }}
        error={error && true}
        {...register}
        onScroll={(e) => {
          if (e.target.scrollTop + e.target.offsetHeight == e.target.scrollHeight) {
            handleLoadMore();
          }
        }}
      >
        {data?.map((item, index) => (
          <MenuItem
            key={index}
            value={item.name ? item.name : item}
            onClick={() => {
              setState(item._id, item.name, item.value && item.value);
            }}
          >
            {item.name ? item.name : item}
          </MenuItem>
        ))}
      </Select>
      {error && <Error message={error} />}
    </FormControl>
  );
}


export function SelectInputField({
  data,
  label,
  error,
  register,
  disable,
  stateValue,
  setState,
}) {
  const handleClear = () => {
    setState("");
  }
  return (
    <FormControl size="small" fullWidth variant="outlined">
      {/* <InputLabel>{label}</InputLabel> */}
      <TextField
        select
        focused={true}
        disabled={disable}
        value={stateValue ?? ""}
        label={label}
        sx={{
          textAlign: "left",
          mb: error ? "0px" : 2,
        }}
        error={error && true}
        {...register}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ pr: "20px" }}>
              {stateValue ? (
                <Close fontSize="small" onClick={handleClear} />
              ) : null}
            </InputAdornment>
          )
        }}
      >
        {data?.map((item, index) => (
          <MenuItem
            key={index}
            value={item.name ? item.name : item}
            onClick={() => {
              setState(item._id, item.name);
            }}
          >
            {item.name ? item.name : item}
          </MenuItem>
        ))}
      </TextField>
      {error && <Error message={error} />}
    </FormControl>
  );
}